module.exports = __webpack_public_path__ + "static/media/image2.ff3513f2.svg";